export class InputOrder {
  id: number;
  orderValue = 0;
  orderDeliveredValue = 0;
  percentageDeliveredUnderValue = 0;
  orderQuantity = 0;
  orderDeliveredQuantity = 0;
  percentageDeliveredUnderQuantity = 0;
}
